
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useLocation } from "react-router-dom";
import { usePlan } from "../../Context/PlanContext";
import {
  useSubworkspaceStore,
  useUserStore,
  useWorkspaceStore,
} from "../../Context/store";

import MessageToggleNav from "../Sidebar/MessageToggleNav";
import ForumsFeedbar from "./ForumsFeedbar";
import ForumTitle from "./ForumTitle";
import WorkspaceFeedbar from "./WorkspaceFeedbar";
import WorkspaceTitle from "./WorkspaceTitle";
export default function MobileFeedBarV1({ closeDrawer, openSidebarDrawer }) {
  const location = useLocation();
  const { pathname } = location;
  const { selectedWorkspace } = useWorkspaceStore();
  const { selectedSubWorkspace, subWorkspaceList } = useSubworkspaceStore();
  const { user: loggedInUser } = useUserStore();
  const { currentPlan } = usePlan();

  return (
    <section
      className={` overflow-scroll rounded-none  ${
        openSidebarDrawer ? "" : "hidden"
      }`}
    >
      <div className="flex justify-end">
        <XMarkIcon
          className="h-6 w-6 cursor-pointer"
          onClick={closeDrawer}
          aria-hidden="true"
        />
      </div>
      {/* <NavigationButton/> */}
      <div className="h-16 px-4 flex justify-between items-center ">
        {pathname !== "/createprofile" && <WorkspaceTitle />}
      </div>
      <hr className=" bg-gray-800 border dark:bg-gray-700" />
      <div className="my-1">
        <WorkspaceFeedbar
          loggedInUser={loggedInUser}
          pathname={pathname}
          selectedWorkspace={selectedWorkspace}
          currentPlan={currentPlan}
        />
      </div>
      <hr className=" bg-gray-800 border dark:bg-gray-700" />
      {subWorkspaceList?.length > 0 && (
        <>
          <ForumTitle />
          <hr className=" bg-gray-800 border dark:bg-gray-700" />
          <div className="flex h-12 flex-col justify-center px-4">
            <p className="text-secondary font-semibold md:font-normal md:text-debatePalette-hr text-sm">FORUMS</p>
          </div>
          <ForumsFeedbar
            loggedInUser={loggedInUser}
            pathname={pathname}
            selectedSubWorkspace={selectedSubWorkspace}
            currentPlan={currentPlan}
          />
        </>
      )}
      <MessageToggleNav currentPlan={currentPlan} />
    </section>
  );
}
